import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import graphqlClient, { resetGraphqlClient } from '../../logic/graphql/graphql-client';
import Auth from '../../logic/redux/auth';
import { Provider as URQLProvider, Client } from 'urql';

const ResetableUrqlProvider = (props: { children: JSX.Element }): JSX.Element => {
  const dispatch = useDispatch();

  const [client, setClient] = useState<Client>(graphqlClient);

  const shouldResetClient = useSelector(Auth.select.selectShouldResetClient);

  useEffect(() => {
    if (shouldResetClient) {
      setClient(resetGraphqlClient());
      dispatch(Auth.actions.setShouldResetClient(false));
      window.location.reload();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shouldResetClient]);

  return <URQLProvider value={client}>{props.children}</URQLProvider>;
};

export default ResetableUrqlProvider;
